import React, { useContext, useEffect } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import NetworkBarLink from './_partials/NetworkBarLink';
import HomeIcon from '../Icons/Home';
import Eyecon from '../Icons/FollowingWatch';
import PopularIcon from '../Icons/Popular';
import DailyDeviationIcon from '../Icons/DailyDeviation';
import TopicsIcon from '../Icons/Topics';
import NewestIcon from '../Icons/Newest';
import RecommendedIcon from '../Icons/Recommended';
import { SessionContext } from '../Context/SessionContext';
import { MobileContext } from '../Context/MobileContext';
import GroupList from './_partials/GroupList';
import { watchedGroupsStreamId, recommendedGroupsStreamId, } from './redux/constants';
import { Nav } from '../a11y/headings/tagWrappers';
import { VisuallyHidden } from '../a11y';
import Heading from '../a11y/headings/Heading';
import Label from './_partials/Label';
import EmptyWatchedGroups from './_partials/EmptyWatchedGroups';
import { BiLoggerContextProvider } from '../biLogger/BiLogger.context';
import s from './NetworkBar.scss';
var menuItemIconMap = {
    home: HomeIcon,
    deviantsYouWatch: Eyecon,
    dailyDeviations: DailyDeviationIcon,
    topics: TopicsIcon,
    popular: PopularIcon,
    new: NewestIcon,
};
var NetworkBar = function (_a) {
    var initialFetch = _a.initialFetch, _b = _a.isVisible, isVisible = _b === void 0 ? true : _b, isCollapsed = _a.isCollapsed, selectedItem = _a.selectedItem, showWatchedGroupsEmptyState = _a.showWatchedGroupsEmptyState, className = _a.className, isInitialized = _a.isInitialized, mainNavItems = _a.mainNavItems;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var tabIndex = isVisible ? 0 : -1;
    useEffect(function () {
        if (!isInitialized) {
            initialFetch();
        }
    }, [initialFetch, isInitialized]);
    return (React.createElement(Nav, { className: classnames(s['root'], isCollapsed && s['collapsed'], className) },
        React.createElement(VisuallyHidden, null,
            React.createElement(Heading, null, t('common.networkBar'))),
        React.createElement("ul", null, mainNavItems.map(function (item) {
            var _a;
            return item &&
                (!item.restrictLoggedIn || isLoggedIn) && (React.createElement("li", { key: item.key },
                React.createElement(NetworkBarLink, { label: item.key, url: item.url, icon: menuItemIconMap[item.key], tabIndex: tabIndex, isCollapsed: !isMobile && isCollapsed, isSelected: selectedItem === ((_a = item.pageType) !== null && _a !== void 0 ? _a : item.key), hasNewContent: item.hasNewContent })));
        })),
        React.createElement("div", { className: s['group'] },
            React.createElement(BiLoggerContextProvider, { value: { sectionname: 'groups' } },
                showWatchedGroupsEmptyState && !isCollapsed && (React.createElement(React.Fragment, null,
                    React.createElement(Label, { className: s['label'], isCollapsed: isCollapsed }, t('networkBar.subheader.groups')),
                    React.createElement(EmptyWatchedGroups, null))),
                !showWatchedGroupsEmptyState && (React.createElement(GroupList, { streamId: watchedGroupsStreamId, tabIndex: tabIndex, selectedItem: selectedItem, isCollapsed: isCollapsed },
                    React.createElement(Label, { className: s['label'], isCollapsed: isCollapsed }, t('networkBar.subheader.groups'))))),
            React.createElement(BiLoggerContextProvider, { value: { sectionname: 'recommended groups' } },
                React.createElement(GroupList, { streamId: recommendedGroupsStreamId, tabIndex: tabIndex, selectedItem: selectedItem, isCollapsed: isCollapsed },
                    isCollapsed && (React.createElement(RecommendedIcon, { disableDefaultColors: true, customSizable: true, className: s['recommended-separator'] })),
                    React.createElement(Label, { className: s['label'], isCollapsed: isCollapsed }, t('networkBar.subheader.recommendedGroups')))))));
};
NetworkBar.displayName = 'NetworkBar';
export default NetworkBar;
//# sourceMappingURL=NetworkBar.js.map